export const SH1_WIDTH = 1920;
export const SH1_RATIO = 1.77;
export const ACCURACY = 2;
export const DEFAULT_FONT_SIZE = 16;
